<template>
  <div
    class="flex flex-direction justify-center align-center login-container min-body-height bg-white"
  >
    <el-card
      :class="
        (UI.isMobile ? 'full-item' : 'margin-50') +
          ' ' +
          (UI.clientHeight < 800 ? 'scroll-y' : '')
      "
    >
      <div slot="header" class="clearfix">
        <span>登录</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="toRegistry()"
        >
          注册
        </el-button>
      </div>
      <Login :class="UI.isMobile ? 'mobile-login-box' : 'login-box'"></Login>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Login from './login.vue';

export default {
  components: {
    Login,
  },

  computed: {
    ...mapState(['UI']),
  },

  methods: {
    toRegistry: function() {
      this.$router.replace({
        name: 'registry',
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/login/index.vue